module.exports = __webpack_public_path__ + "static/media/sample4.e7dab269.png";